import { Injectable } from '@angular/core';
import { BcKeyboardService } from 'common/keyboard-service/keyboard.service';
import { AddKeyHandlerAction, AddKeyHandlerOptions, KeyboardHandlerModel } from 'common/keyboard-service/keyboard-handler.model';

@Injectable({
  providedIn: 'root'
})
export class BcLocalKeyboardHandlerFactory {

  constructor(private _keyboardService: BcKeyboardService) {
  }

  public createFromElement(element: Element): KeyboardHandlerModel {
    const keyboardHandler = {
      combinations: [],
      addKeyHandler: (key: string, action: AddKeyHandlerAction, options: AddKeyHandlerOptions) => {
        const optionsCopy = { ...options };

        if (typeof optionsCopy.stopEvent === 'undefined') {
          optionsCopy.stopEvent = true;
        }

        keyboardHandler.combinations.push(this._keyboardService.bindToElement(key, action, element, optionsCopy));
      }
    };

    return keyboardHandler;
  }
}
